import React from 'react'

const Scrollable = ({ children }: { children: React.ReactNode }) => (
  <div className="w-full h-[358px] overflow-y-auto rounded-b pb-[37px] pt-3 px-2.5">{children}</div>
)

export default Scrollable
